"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgSearch = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props, {
  children: [(0, jsx_runtime_1.jsxs)("g", Object.assign({
    "data-name": "Search",
    transform: "translate(4 4)",
    fill: "none"
  }, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M0 0h16v16H0z"
    }, void 0), (0, jsx_runtime_1.jsx)("circle", {
      cx: 5.5,
      cy: 5.5,
      r: 5.5,
      transform: "translate(1 1)",
      stroke: "#2d5dec",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Stroke",
      d: "M10.39 10.39L15 15",
      stroke: "#2d5dec",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }, void 0)]
  }), void 0), (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Rectangle 540",
    fill: "none",
    d: "M0 0h24v24H0z"
  }, void 0)]
}), void 0);

exports.default = SvgSearch;